import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  userLoggedIn = false;
  errorMessage = null;
  showSpinner = false;

  version = environment.version;

  constructor(private authService: AuthService,
              private router: Router,
              private snackBar: MatSnackBar) { }

  ngOnInit() 
  {
    // Check to See if the user is logged in and set the Com
    this.userLoggedIn = this.authService.checkLoginStatus();
    if(this.userLoggedIn)
    {
      // If the user is logged in and on the login page goto Landing Page component
      this.router.navigate(['/landing-page']);
    }

  }

  onLogin(formParm) 
  {

    // Show Spinner
    this.showSpinner = true;
    // console.log('Login Form : ', formParm.value);

    this.authService.login(formParm.value)
      .subscribe(
        (data: any) => 
        {
          this.router.navigate(['/director-landing-page']);
        },
        (error) => 
        {
          console.log('Error Message : ',  error);          
          // Show Error
          this.showSpinner = false;
          this.snackBar.open(error.error.message, null, { duration: 5000 });
        }
      );
    }
    
  // onStayLoggedIn(event)
  // {
  //   console.log(event.checked);
  // }

}
